var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4668 10.667V10.7451H8.79492V10.667C8.81445 9.60579 9.12044 9.13704 9.90169 8.66178C10.7285 8.15397 11.2298 7.45736 11.2298 6.40918C11.2298 4.9248 10.097 3.90918 8.4043 3.90918C6.85482 3.90918 5.60482 4.81413 5.55273 6.47428H6.95898C7.01758 5.51074 7.70117 5.08105 8.4043 5.08105C9.18555 5.08105 9.81055 5.59538 9.81055 6.40918C9.81055 7.09277 9.39388 7.57454 8.84701 7.90658C7.98763 8.44043 7.48633 8.96126 7.4668 10.667ZM7.25846 12.6331C7.25195 13.141 7.67513 13.5511 8.18294 13.5576C8.68424 13.5511 9.10091 13.141 9.10742 12.6331C9.10091 12.1253 8.68424 11.7087 8.18294 11.7087C7.67513 11.7087 7.25195 12.1253 7.25846 12.6331Z",
    fill: "#55595F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.957031,
    y: 1.2998,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#55595F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhat);
export default __webpack_public_path__ + "static/media/what.048fcad600672fd0b19986f57f35a54c.svg";
export { ForwardRef as ReactComponent };